import React from "react";
import classes from "./list-fields.module.scss";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ListFields = ({ title, data, nameInput, placeholderInput, onChange, onGetRemovedElement }) => {
  const onHandleChange = (value, key) => {
    const newData = data.map((element) => (element.key === key ? { ...element, value } : element));
    onChange(newData);
  };

  const onCreateField = () => {
    onChange([...data, { key: Math.floor(Math.random() * (99999 - 11111 + 1) + 11111), value: "" }]);
  };

  return (
    <div className={classes["list-fields"]}>
      <h4>{title}</h4>
      <div className={classes["list-fields__add-button"]} onClick={onCreateField}>
        Добавить поле
      </div>
      {data.map((element) => (
        <div key={element.key} className={classes["list-fields__wrap"]}>
          <input
            type="text"
            name={`${nameInput}-${element.key}`}
            placeholder={placeholderInput || ""}
            value={element.value}
            onChange={(e) => onHandleChange(e.target.value, element.key)}
          />
          <div
            className={classes["list-fields__remove-button"]}
            onClick={() => onGetRemovedElement(element.key)}>
            <FontAwesomeIcon icon={faTrash} size="1x" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListFields;
